/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SubcontractorCompanyResultResource } from './';
import {
    SubcontractorCompanyResultResourceFromJSON,
    SubcontractorCompanyResultResourceFromJSONTyped,
    SubcontractorCompanyResultResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubcontractorSearchResultResource
 */
export interface SubcontractorSearchResultResource {
    /**
     * 
     * @type {Array<SubcontractorCompanyResultResource>}
     * @memberof SubcontractorSearchResultResource
     */
    items: Array<SubcontractorCompanyResultResource>;
    /**
     * 
     * @type {number}
     * @memberof SubcontractorSearchResultResource
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof SubcontractorSearchResultResource
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubcontractorSearchResultResource
     */
    hasNext: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubcontractorSearchResultResource
     */
    hasPrevious: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubcontractorSearchResultResource
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SubcontractorSearchResultResource
     */
    pageSize: number;
}

/**
 * Check if a given object implements the SubcontractorSearchResultResource interface.
 */
export function instanceOfSubcontractorSearchResultResource(value: object): value is SubcontractorSearchResultResource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('hasNext' in value) || value['hasNext'] === undefined) return false;
    if (!('hasPrevious' in value) || value['hasPrevious'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function SubcontractorSearchResultResourceFromJSON(json: any): SubcontractorSearchResultResource {
    return SubcontractorSearchResultResourceFromJSONTyped(json, false);
}

export function SubcontractorSearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubcontractorSearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SubcontractorCompanyResultResourceFromJSON)),
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
        'hasNext': json['hasNext'],
        'hasPrevious': json['hasPrevious'],
        'page': json['page'],
        'pageSize': json['pageSize'],
    };
}

export function SubcontractorSearchResultResourceToJSON(value?: SubcontractorSearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => SubcontractorCompanyResultResourceToJSON(v))),
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
        'hasNext': value['hasNext'],
        'hasPrevious': value['hasPrevious'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

